import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { ATOM_KEY } from "../keys";

const paidMethodAtom = atom({
    key: ATOM_KEY.PAID_METHOD,
    default: "",
});

export const usePaidMethodRecoilState = () => useRecoilState(paidMethodAtom);
export const usePaidMethodRecoilValue = () => useRecoilValue(paidMethodAtom);
export const useSetPaidMethodRecoilState = () => useSetRecoilState(paidMethodAtom);
